import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _dec3, _class2, _descriptor, _descriptor2, _Class_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Controller, { inject as controller } from "@ember/controller";
import { computed } from "@ember/object";
import { service } from "@ember/service";
import I18n from "discourse-i18n";
let _class = (_dec = computed("viewingSelf", "router.currentRoute.name", "currentUser.admin"), _dec2 = computed("pmTopicTrackingState.newIncoming.[]", "pmTopicTrackingState.statesModificationCounter", "pmTopicTrackingState.isTracking"), _dec3 = computed("pmTopicTrackingState.newIncoming.[]", "pmTopicTrackingState.statesModificationCounter", "pmTopicTrackingState.isTracking"), (_class2 = (_Class_brand = /*#__PURE__*/new WeakSet(), class _class2 extends Controller {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _Class_brand);
    _initializerDefineProperty(this, "router", _descriptor, this);
    _initializerDefineProperty(this, "user", _descriptor2, this);
  }
  get viewingSelf() {
    return this.user.viewingSelf;
  }
  get showWarningsWarning() {
    return this.router.currentRoute.name === "userPrivateMessages.user.warnings" && !this.viewingSelf && !this.currentUser.isAdmin;
  }
  get newLinkText() {
    return _assertClassBrand(_Class_brand, this, _linkText).call(this, "new");
  }
  get unreadLinkText() {
    return _assertClassBrand(_Class_brand, this, _linkText).call(this, "unread");
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "user", [controller], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "showWarningsWarning", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "showWarningsWarning"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "newLinkText", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "newLinkText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "unreadLinkText", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "unreadLinkText"), _class2.prototype)), _class2));
function _linkText(type) {
  const count = this.pmTopicTrackingState?.lookupCount(type, {
    inboxFilter: "user"
  });
  if (count === 0) {
    return I18n.t(`user.messages.${type}`);
  } else {
    return I18n.t(`user.messages.${type}_with_count`, {
      count
    });
  }
}
export { _class as default };